module.exports = __webpack_public_path__ + "media/images/clients/big_watches-34150208a1ba6eccd913b370e10051d7.svg";